import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../_metronic/helpers'
import {useEffect, useState} from 'react'
import Loading from '../../modules/loading'
import useModalScrollPreservation from '../../hook/useModalScrollPreservation'

export interface ConfirmationModalDialog {
  uniqueID?: string | number
  show: boolean
  onClose: () => void
  onAction?: any
  onCancel?: () => void
  isOperationLoading?: boolean
  isLoading?: boolean
  isDataLoading?: boolean
  body?: any
  actionName?: string
  actionBtnClass?: string
  cancelBtnName?: string
  cancelBtnClass?: string
  title?: any
  bodyClass?: string
  dialogClassName?: string
  disableAction?: boolean
  okayBtnClass?: string
  modalClass?: string
  isDisabled?: boolean
  disableFooter?: boolean
  isCloseOnBackdrop?: boolean
}

const ConfirmationModal = ({
  uniqueID,
  show,
  onClose,
  onAction,
  onCancel,
  isOperationLoading,
  isLoading = false,
  isDataLoading = false,
  body,
  actionName,
  actionBtnClass,
  cancelBtnName,
  cancelBtnClass,
  title,
  bodyClass,
  disableAction,
  okayBtnClass,
  modalClass = '',
  dialogClassName = '',
  isDisabled = false,
  disableFooter = false,
  isCloseOnBackdrop = true,
}: ConfirmationModalDialog) => {
  const [isOperationPerformed, setIsOperationPerformed] = useState(false)

  const scrollPreservation = useModalScrollPreservation()
  const handleClose = scrollPreservation.createCloseHandler(onClose)

  useEffect(() => {
    if (isDataLoading && isOperationPerformed) {
      handleClose()
      setIsOperationPerformed(false)
    }
    //eslint-disable-next-line
  }, [isDataLoading, isOperationPerformed])

  if (!show) {
    return null
  }

  const onClickAction = () => {
    setIsOperationPerformed(true)
    if (uniqueID && onAction) {
      onAction(uniqueID)
    } else if (!uniqueID && onAction) {
      onAction()
    }
  }

  const onClickCancel = () => {
    if (onCancel) {
      onCancel()
    } else {
      onClose()
    }
  }

  return (
    <Modal
      className={`modal ${modalClass} fade`}
      id='kt_modal'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={show}
      dialogClassName={dialogClassName ? dialogClassName : 'modal-l'}
      onHide={handleClose}
      backdrop={isCloseOnBackdrop ? undefined : 'static'}
      enforceFocus={false}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h4 className='modal-title w-100'>{title ? title : 'Are you sure?'}</h4>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div
          className={`modal-body ${bodyClass ? bodyClass : ''} ${
            isLoading ? 'position-relative min-h-350px' : ''
          }`}
        >
          {isLoading && <Loading />}
          {body ? (
            body
          ) : (
            <>
              <p className='mb-2'>Do you really want to delete this record?</p>
              <p>This action is irreversible.</p>
            </>
          )}
        </div>

        {!disableFooter && (
          <div className='modal-footer'>
            {!disableAction && (
              <button
                type='button'
                className={cancelBtnClass || 'btn btn-outline btn-active-light-primary'}
                onClick={onClickCancel}
              >
                {cancelBtnName || (onAction ? 'Cancel' : 'Close')}
              </button>
            )}
            {onAction &&
              (!isOperationLoading ? (
                <>
                  {disableAction ? (
                    <button
                      type='button'
                      className={`btn ${okayBtnClass ? okayBtnClass : 'btn-danger'}`}
                      onClick={handleClose}
                    >
                      Okay
                    </button>
                  ) : (
                    <button
                      type='submit'
                      className={`btn ${actionBtnClass ? actionBtnClass : 'btn-danger'}`}
                      onClick={onClickAction}
                      disabled={isDisabled || isLoading}
                    >
                      <span className='indicator-label'>{actionName ? actionName : 'Yes'}</span>{' '}
                    </button>
                  )}
                </>
              ) : (
                <button
                  className={`btn ${actionBtnClass ? actionBtnClass : 'btn-danger'}`}
                  disabled={isDisabled || isLoading}
                >
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                </button>
              ))}
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ConfirmationModal
